module.exports = __webpack_public_path__ + "static/media/underConstruction.d84f714d.png";